<template>
  <div>
    <div v-if="program.type !== 1" class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">زمانبندی پخش</h3>
        </div>
        <div class="card-toolbar">
          <div v-show="!schedulesLoaded" class="spinner mr-3"></div>
        </div>
      </div>
      <div class="card-body">
        <form ref="create_program_schedule">
          <div class="form-group row">
            <div class="col-5">
              <label>شروع:</label>
              <date-picker
                type="datetime"
                v-model="form.start"
                name="start"
                format="YYYY-MM-DD HH:mm:ss"
                display-format="jYYYY/jMM/jDD HH:mm"
                :min="this.prettyDate(new Date())"
                color="#4554a0"
                label="تاریخ شروع"
              />
            </div>
            <div class="col-5">
              <label>پایان:</label>
              <date-picker
                type="datetime"
                v-model="form.end"
                name="end"
                format="YYYY-MM-DD HH:mm:ss"
                display-format="jYYYY/jMM/jDD HH:mm"
                :min="form.start"
                color="#4554a0"
                label="تاریخ پایان"
              />
            </div>
            <div class="col-2">
              <button
                type="button"
                class="btn btn-primary mt-8"
                ref="submit_btn"
                @click="save"
              >
                <i class="flaticon2-plus p-0"></i>
              </button>
            </div>
          </div>
        </form>
        <div v-if="schedules.length" class="table-responsive mb-15">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>شروع</th>
                <th>پایان</th>
                <th>توضیحات</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="schedule in schedules"
                :key="`schedule-${schedule.id}`"
              >
                <td dir="ltr" class="text-nowrap">
                  <span class="time-style">
                    <span class="icon-style"
                      ><i class="far fa-1x fa-play"></i
                    ></span>
                    {{ formatDate(schedule.start) }}
                    <i class="far fa-1x fa-clock pt-1"></i>
                  </span>
                </td>
                <td dir="ltr" class="text-nowrap">
                  <span v-if="schedule.end" class="time-style">
                    <span class="icon-style"
                      ><i class="far fa-1x fa-pause"></i
                    ></span>

                    {{ formatDate(schedule.end) }}
                    <i class="far fa-1x fa-clock pt-1"></i>
                  </span>
                </td>
                <td>
                  <button
                    class="btn btn-xs btn-outline-danger mr-1"
                    @click="destroy(schedule.id)"
                  >
                    <i class="flaticon2-trash"></i>
                    حذف
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="overflow-auto mt-5" v-if="schedulesPagination.lastPage > 1">
          <b-pagination
            v-model="schedulesPagination.currentPage"
            :total-rows="schedulesPagination.total"
            :per-page="schedulesPagination.perPage"
            @input="getSchedules()"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/programs/schedules.scss";
.vpd-icon-btn {
  margin-bottom: 0;
}
.time-style {
  border: 1px solid #eeee;
  padding: 10px 7px;
  border-radius: 5%;
}
.icon-style .fa-pause {
  background-color: #f36331;
  padding: 5px 6px;
  color: #ffffff;
  border-radius: 10%;
}
.icon-style .fa-play {
  background-color: #52bd95;
  padding: 5px 6px;
  color: #ffffff;
  border-radius: 10%;
}
</style>

<script>
import { mapGetters } from "vuex";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Swal from "sweetalert2";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  DESTROY_SCHEDULE,
  FETCH_SCHEDULES,
  STORE_SCHEDULE
} from "@/core/services/store/schedules.module";
import { FETCH_PROGRAM } from "@/core/services/store/programs.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";

export default {
  name: "programs-schedules",
  data() {
    return {
      schedulesLoaded: false,
      isCompany: this.$route.name.startsWith("company"),
      form: {
        start: null,
        end: null
      }
    };
  },
  components: {
    datePicker: VuePersianDatetimePicker
  },
  mounted() {
    let programId = this.$route.params.id;
    this.$store.dispatch(FETCH_PROGRAM, programId).then(() => {
      this.$store.dispatch(SET_ACTIONS, {
        links: [
          {
            name: "بازگشت",
            to: {
              name: "programs-show",
              params: { id: programId }
            }
          }
        ]
      });
      this.setBreadcrumbs();
      this.getSchedules();
    });

    this.fv = formValidation(this.$refs.create_program_schedule, {
      fields: {
        start: {
          validators: {
            notEmpty: {
              message: "شروع خالی است"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  computed: {
    ...mapGetters(["program", "schedules", "schedulesPagination"])
  },
  methods: {
    setBreadcrumbs() {
      let programsRouteName = "programs-index";
      let programRouteName = "programs-show";

      let items = [];
      if (this.isCompany) {
        programsRouteName = "company-programs-index";
        programRouteName = "company-programs-show";

        items.push({
          title: this.currentUserProperty.title ?? "شرکت",
          route: { name: "company-dashboard" }
        });
      }

      items.push({ title: "برنامه‌‌ها", route: { name: programsRouteName } });
      items.push({
        title: this.program.name,
        route: { name: programRouteName, params: { id: this.program.id } }
      });
      items.push({ title: "زمانبندی" });

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    getSchedules() {
      this.schedulesLoaded = false;
      this.$store
        .dispatch(FETCH_SCHEDULES, this.program.id)
        .then(() => {
          this.schedulesLoaded = true;
        })
        .catch(() => {
          this.schedulesLoaded = true;
        });
    },
    save() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = this.$refs.submit_btn;
          this.disableBtn(submitBtn);

          let start = this.gDate(this.form.start);
          let end = null;
          if (this.form.end) {
            end = this.gDate(this.form.end);
          }
          this.$store
            .dispatch(STORE_SCHEDULE, {
              programId: this.program.id,
              start: start,
              end: end
            })
            .then(() => {
              this.getSchedules();
              this.enableBtn(submitBtn);
              if (this.form.end) {
                this.form.start = this.form.end;
              }
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    },
    destroy(id) {
      let programId = this.program.id;
      Swal.fire({
        title: "",
        text: "آیا از حذف زمانبندی اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_SCHEDULE, { programId, id }).then(() => {
            this.getSchedules();
            Swal.fire({
              position: "center",
              icon: "success",
              title: "حذف با موفقیت انجام شد.",
              showConfirmButton: false,
              timer: 1500
            });
          });
        }
      });
    }
  }
};
</script>
